<template>
    <div id="home-container">
        <Head>
            <title>Next Gen Math</title>
            <meta name="description" content="">
        </Head>
        <hero-background></hero-background>
        <hero></hero>
        <partner-type-buttons></partner-type-buttons>
        <video-section></video-section>
        <section id="tagline" class="tagline text-center py-5 py-sm-0">
            <h2 class="display-4">
                <span class="fredericka">Dynamic</span> resources for
                <span class="knewave"> unlimited</span> opportunities
            </h2>
        </section>
        <b-container class="my-5">
            <b-row>
                <b-col cols="12" md="5" class="my-md-4 py-md-4">
                    <!-- <b-img :src="`${routes.cdn_url}/images/redesign/animals/monkey.svg`" class="animal-svg" alt=""></b-img> -->
                    <monkey></monkey>
                </b-col>
                <b-col cols="12" md="7" class="my-md-4 py-md-4">
                    <h2>Standards Practice</h2>
                    <p>
                        Build customized class assignments, blended learning activities, exit tickets, spiral review, or formative and summative assessments using our rigorous, dynamic, and unlimited questions that are organized by standard and question type.
                    </p>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" md="7" class="my-md-4 py-md-4">
                    <h2>Real Time Data</h2>
                    <p>
                        Access real time data for real time teaching to meet the needs of your diverse learners and ensure equitable learning for all students.
                    </p>
                </b-col>
                <b-col cols="12" md="5" class="my-md-4 py-md-4">
                    <!-- <b-img :src="`${routes.cdn_url}/images/redesign/animals/llama-teacher.svg`" class="animal-svg" alt=""></b-img> -->
                    <llama></llama>
                </b-col>
            </b-row>
                <b-row>
                <b-col cols="12" md="5">
                    <!-- <b-img :src="`${routes.cdn_url}/images/redesign/animals/rabbit.svg`" class="animal-svg" alt=""></b-img> -->
                    <rabbit></rabbit>
                </b-col>
                <b-col cols="12" md="7" class="mt-md-4 pt-md-4">
                    <h2>Procedural Fluency</h2>
                    <p>
                        Address learning loss with basic skills practice for K-12th grade students that can be customized by adjusting the number, type and/or formatting of problems.
                    </p>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" md="7" class="my-md-4 py-md-4">
                    <h2>Blended Learning</h2>
                    <p>
                        Reflect on lesson success by viewing class performance on individual standards and question types. One click creates blended learning groups by standard. Assign students reteach standards, and the intervention journey begins.
                    </p>
                </b-col>
                <b-col cols="12" md="5" class="animal-svg-container">
                    <b-img :src="`${routes.cdn_url}/images/redesign/animals/representation.svg`" class="animal-svg" loading="lazy" alt=""></b-img>
                </b-col>
            </b-row>
        </b-container>
        
        <CurrentEventsSection />
            
        <section class="testimonials-scene">
            <div class="sky">
                <img class="sky-img" :src="`${routes.cdn_url}/images/redesign/testimonials/background.png`" loading="lazy" alt="">
            </div>
            <div id="testimonials-carousel-container">
                <div id="bubble-container"> 
                    <testimonials-carousel></testimonials-carousel>
                </div>
            </div>
            <div id="testimonials-foreground-wrapper">
                <whale-boat></whale-boat>
                <ocean></ocean>
            </div>
        </section>
    </div>
</template>

<script>
    import CurrentEventsSection from '../components/CurrentEventsSection.vue';
    import HeroBackground from '../components/HeroBackground.vue';
    import Hero from '../components/Hero.vue';
    import PartnerTypeButtons from '../components/PartnerTypeButtons.vue';
    import ContactShortcutButton from '../components/ContactShortcutButton.vue';
    import ToggleCollapseButton from '../components/ToggleCollapseButton.vue';
    import VideoSection from '../components/VideoSection.vue';
    import Monkey from '../components/AnimalGraphics/Monkey.vue';
    import Llama from '../components/AnimalGraphics/Llama.vue';
    import Rabbit from '../components/AnimalGraphics/Rabbit.vue';
    import Ocean from '../components/AnimalGraphics/TestimonialsOcean.vue';
    import WhaleBoat from '../components/AnimalGraphics/TestimonialsForeground.vue';
    import TestimonialsCarousel from '../components/TestimonialsCarousel.vue';

    export default {
        components: {
            HeroBackground,
            Hero,
            PartnerTypeButtons,
            ContactShortcutButton,
            ToggleCollapseButton,
            VideoSection,
            Monkey,
            Llama,
            Rabbit,
            Ocean,
            WhaleBoat,
            TestimonialsCarousel,
            CurrentEventsSection,
        },
    }
</script>

<style lang="scss" scoped>
#home-container {
    margin-bottom: -1em;
}

.row {
    margin: 0;
    justify-content: space-between;
    flex-wrap: nowrap;
}

.bg-0 {
    width: 100%;
    height: 100%;
    background: rgb(183, 224, 122);
    border-radius: 50%;
    position: absolute;
    z-index: 0;
}

.bg-blue {
    background: #2673c3;
    p {
        color: #fff;
    }
}

.knewave {
    font-family: 'Knewave', cursive;
    color: #3987D8;
}

.fredericka {
    font-family: 'Fredericka the Great', cursive;
    color: #212529;
}

.font-24 {
    font-size: 24px;
}

.testimonials-scene {
    padding-top: 45vh;
}
.sky {
    width: 100%;
    position: absolute;
    margin-top: -45vh;
    z-index: -5;
    overflow: hidden;
}

.sky-img {
    width: 100%;
}

#testimonials-carousel-container {
    width: 100%;
    margin-top: -25vh;
    display: flex;
    justify-content: center;
}

#testimonials-foreground-wrapper {
    position: relative;
    margin-top: 16vh;
}

#bubble-container {
    width: 50%;
}
@media (max-width: 1600px) {
    #bubble-container {
        // margin-left: 25%;
        width: 40%;
    }
}
@media (max-width: 1400px) {
    #bubble-container {
        // margin-left: 20%;
        width: 50%;
    }
    #testimonials-foreground-wrapper {
        margin-top: 20vh;
    }

    #testimonials-carousel-container {
        margin-top: -30vh;
    }
}
@media (max-width: 1200px) {
    #bubble-container { 
        // margin-left: 15%;
        width: 50%;
    }
}
@media (max-width: 992px) {
    .animal-svg {
        width: 250px;
        margin-top: 0;
    }
    #bubble-container {
        // margin-left: 12%;
        width: 50%;
    }
}
@media (max-width: 768px) {
    .animal-svg-container {
        display: flex;
        justify-content: center;
        .animal-svg {
            width: 350px;
        }
    }
    .row {
        justify-content: space-between;
        flex-wrap: wrap;
    }

    #bubble-container {
        // margin-left: 5%;
        width: 70%;
    }

    #testimonials-foreground-wrapper {
        margin-top: 30vh;
    }

    #testimonials-carousel-container {
        margin-top: -40vh;
    }
}
@media (max-width: 576px) {
    #bubble-container {
        // margin-left: 5%;
        width: 90%;
    }

    .sky {
        height: 70vh;
    }
    .sky-img {
        width: unset;
        height: 100%;
    }

    #testimonials-foreground-wrapper {
        margin-top: 35vh;
    }

    #testimonials-carousel-container {
        margin-top: -40vh;
    }
}
</style>
